export default __webpack_public_path__ + "static/media/Card.c24acd0a.svg";